import { IDeleteMultipleBaseRequest } from "../../../models/request/base/deleteRequest"
import { ITKBPreviewByLopRequest } from "../../../models/request/thoi-khoa-bieu/ITKBPreviewByLopRequest"
import { nt_thoi_khoa_bieu } from "../../../models/response/thoi-khoa-bieu/nt_thoi_khoa_bieu"
import { IThoiKhoaBieuPreviewItem } from "../../../models/response/thoi-khoa-bieu/ThoiKhoaBieuPreviewItem"

export enum eThoiKhoaBieuActionTypeIds {
    LOAD_START = "TKB_LOAD_START",
    LOAD_SUCCESS = "TKB_LOAD_SUCCESS",
    LOAD_ERROR = "TKB_LOAD_ERROR",

    LOAD_PREVIEW_BYLOP_START = "TKB_LOAD_PREVIEW_BYLOP_START",
    LOAD_PREVIEW_BYLOP_SUCCESS = "TKB_LOAD_PREVIEW_BYLOP_SUCCESS",
    LOAD_PREVIEW_BYLOP_ERROR = "TKB_LOAD_PREVIEW_BYLOP_ERROR",

    SHOW_DETAIL = "TKB_SHOW_DETAIL",
    CLOSE_DETAIL = "TKB_CLOSE_DETAIL",

    CHANGE_SELECTED_IDS = "TKB_CHANGE_SELECTED_IDS",

    SHOW_CONFIRM = "TKB_SHOW_CONFIRM",
    CLOSE_CONFIRM = "TKB_CLOSE_CONFIRM",

    DELETE_START = "TKB_DELETE_START",
    DELETE_SUCCESS = "TKB_DELETE_SUCCESS",
    DELETE_ERROR = "TKB_DELETE_ERROR",

    SAVE_START = "TKB_SAVE_START",
    SAVE_SUCCESS = "TKB_SAVE_SUCCESS",
    SAVE_ERR = "TKB_SAVE_ERR"
}

export interface IThoiKhoaBieuLoadStart {
    type: eThoiKhoaBieuActionTypeIds.LOAD_START,
}
export interface IThoiKhoaBieuLoadSuccess {
    type: eThoiKhoaBieuActionTypeIds.LOAD_SUCCESS,
    payload: nt_thoi_khoa_bieu[]
}
export interface IThoiKhoaBieuLoadErr {
    type: eThoiKhoaBieuActionTypeIds.LOAD_ERROR,
    payload: string
}

export interface IThoiKhoaBieuLoadPreviewByLopStart {
    type: eThoiKhoaBieuActionTypeIds.LOAD_PREVIEW_BYLOP_START,
    payload: ITKBPreviewByLopRequest
}
export interface IThoiKhoaBieuLoadPreviewByLopSuccess {
    type: eThoiKhoaBieuActionTypeIds.LOAD_PREVIEW_BYLOP_SUCCESS,
    payload: IThoiKhoaBieuPreviewItem[]
}
export interface IThoiKhoaBieuLoadPreviewByLopErr {
    type: eThoiKhoaBieuActionTypeIds.LOAD_PREVIEW_BYLOP_ERROR,
    payload: string
}

export interface IThoiKhoaBieuShowDetail {
    type: eThoiKhoaBieuActionTypeIds.SHOW_DETAIL,
    payload?: nt_thoi_khoa_bieu
}
export interface IThoiKhoaBieuCloseDetail {
    type: eThoiKhoaBieuActionTypeIds.CLOSE_DETAIL,
}
export interface IThoiKhoaBieuChangeSelectedIds {
    type: eThoiKhoaBieuActionTypeIds.CHANGE_SELECTED_IDS,
    payload: number[]
}
export interface IThoiKhoaBieuShowConfirm {
    type: eThoiKhoaBieuActionTypeIds.SHOW_CONFIRM
}
export interface IThoiKhoaBieuCloseConfirm {
    type: eThoiKhoaBieuActionTypeIds.CLOSE_CONFIRM
}

export interface IThoiKhoaBieuDeleteStart {
    type: eThoiKhoaBieuActionTypeIds.DELETE_START,
    payload: IDeleteMultipleBaseRequest
}
export interface IThoiKhoaBieuDeleteSuccess {
    type: eThoiKhoaBieuActionTypeIds.DELETE_SUCCESS,
}
export interface IThoiKhoaBieuDeleteErr {
    type: eThoiKhoaBieuActionTypeIds.DELETE_ERROR,
    payload: string
}
export interface IThoiKhoaBieuSaveStart {
    type: eThoiKhoaBieuActionTypeIds.SAVE_START,
    payload: nt_thoi_khoa_bieu
}
export interface IThoiKhoaBieuSaveSuccess {
    type: eThoiKhoaBieuActionTypeIds.SAVE_SUCCESS
}
export interface IThoiKhoaBieuSaveErr {
    type: eThoiKhoaBieuActionTypeIds.SAVE_ERR,
    payload: string
}
export type IThoiKhoaBieuActionTypes = IThoiKhoaBieuLoadStart | IThoiKhoaBieuLoadSuccess | IThoiKhoaBieuLoadErr |
    IThoiKhoaBieuLoadPreviewByLopStart | IThoiKhoaBieuLoadPreviewByLopSuccess | IThoiKhoaBieuLoadPreviewByLopErr |
    IThoiKhoaBieuShowDetail | IThoiKhoaBieuCloseDetail |
    IThoiKhoaBieuChangeSelectedIds |
    IThoiKhoaBieuShowConfirm | IThoiKhoaBieuCloseConfirm |
    IThoiKhoaBieuDeleteStart | IThoiKhoaBieuDeleteSuccess | IThoiKhoaBieuDeleteErr |
    IThoiKhoaBieuSaveStart | IThoiKhoaBieuSaveSuccess | IThoiKhoaBieuSaveErr